/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".class[_ngcontent-%COMP%]{font-family:Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue,Arial,sans-serif}a.disabled[_ngcontent-%COMP%]{color:#ff0;cursor:not-allowed;text-decoration:underline}.overflow[_ngcontent-%COMP%]{display:inline-block;white-space:nowrap;overflow:hidden!important;text-overflow:ellipsis;font-style:italic}.overflow[_ngcontent-%COMP%], .text-indigo[_ngcontent-%COMP%]{color:#a200ff}.overflow[_ngcontent-%COMP%]:hover{color:#771414}"];
export { styles as styles };

